import React, { PropTypes } from 'react';
import { Tabs, Modal, Input, Icon, Button, Upload, message, Spin } from 'antd';
import DataService from '../../../lib/DataService';
import UserRoleStore from '../../../stores/UserRoleStore';
import NotificationCountActions from '../../../actions/NotificationCountActions';

const TabPane = Tabs.TabPane;
const { TextArea } = Input;
const confirm = Modal.confirm;

export default class ViewNotificationsOfClassComponent extends React.Component {
  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: props.currentRole,
      classId: props.classId,
      notifications: [],
      unreadStudentsModalVisible: false,
      revokeModalVisible: false,
      revokeModalInfo: {},
      spinning: false,
    };
    // bind this
    this.reloadNotifications = this.reloadNotifications.bind(this);
    this.showUnreadStudentsModal = this.showUnreadStudentsModal.bind(this);
    this.showRevokeModal = this.showRevokeModal.bind(this);
    this.showPhotoViewModal = this.showPhotoViewModal.bind(this);
  }

  componentDidMount() {
    this.reloadNotifications();
  }

  componentWillReceiveProps() {
    this.reloadNotifications();
  }

  reloadNotifications() {
    this.setState({
      spinning: true
    });

    DataService.getNotifications(this.state.classId, true).then(response => {
      this.setState({
        notifications: response,
        spinning: false
      });
      return response;
    }, error => {
      console.log(error);
      message.error("加载失败，请稍后重试");
      this.setState({
        spinning: false
      });
    }).then((response) => {
      if (this.state.currentRole.associatName == "student") {
        DataService.readNotifications(JSON.stringify(response.map(n => n.id)), this.state.currentRole.associatObj.id).then(() => {
          NotificationCountActions.refreshNotificationCount();
        })
      }
    });
  }

  showUnreadStudentsModal(nid) {
    this.setState({
      unreadStudentsModalVisible: true,
      focusedNotificationId: nid
    });
  }

  revokeNotification(nid, classId) {
    this.setState({
      spinning: true
    });

    DataService.revokeNotification(nid, classId).then(response => {
      this.reloadNotifications();
      this.setState({
        revokeModalVisible: false,
        spinning: false
      });
    }, error => {
      console.log(error);
      message.error("撤回通知失败，请稍后重试");
      this.setState({
        revokeModalVisible: false,
        spinning: false
      });
    });
  }

  showRevokeModal(nid) {
    let noti = this.state.notifications.find(n => n.id == nid)
    if (noti.visibility.length <= 1 || this.state.currentRole.associatName == "classRecord") {
      this.setState({
        revokeModalVisible: true,
        revokeModalInfo: {
          content: `已有${noti.read_count}位宝贝家长阅读的此条通知，确认撤回吗？`,
          leftButton: null,
          leftCallback: null,
          rightButton: "确认撤回",
          rightCallback: this.revokeNotification.bind(this, nid, undefined),
        }
      })
    } else {
      this.setState({
        revokeModalVisible: true,
        revokeModalInfo: {
          content: `此条通知已发布到${noti.visibility.length}个班级中，您可选择“全部撤回”则从${noti.visibility.length}个班级中撤回，或选择“仅从本班中撤回”则其他${noti.visibility.length - 1}个班级仍可看见此条通知"`,
          leftButton: "全部撤回",
          leftCallback: this.revokeNotification.bind(this, nid, undefined),
          rightButton: "仅从本班撤回",
          rightCallback: this.revokeNotification.bind(this, nid, this.state.classId),
        }
      })
    }
  }

  showPhotoViewModal(url) {
    this.setState({
      photoViewModalVisible: true,
      viewedPhotoUrl: url
    });
  }

  _photoViewModal() {
    return (
      <Modal wrapClassName="notifications-photo-view-modal" visible={this.state.photoViewModalVisible} onCancel={() => this.setState({photoViewModalVisible: false})} footer={null} >
        {this.state.viewedPhotoUrl && <img className="photo-view-in-modal" key={this.state.viewedPhotoUrl} src={this.state.viewedPhotoUrl} />}
      </Modal>
    )
  }

  render() {
    return (
      <div className="view-notifications-of-class"><Spin spinning={this.state.spinning}>
        {this.state.notifications.map(noti =>
          <div className="notification-container" key={noti.id}>
            <div className="notification-title">{noti.title}</div>
            <div className="notification-time">{noti.created_at.slice(0, 10)}</div>
            {/* <div className="notification-content">{noti.content.split("\n").map((p, index) => <p key={index}>{p}</p>)}</div> */}
            <pre className="notification-content">{noti.content}</pre>
            <div className="notification-photos">
              {noti.photos.map(photo => <img className="noti-photo" onClick={this.showPhotoViewModal.bind(this, photo.remote_url)} key={photo.id} src={photo.remote_url + "?imageView2/1/w/120"} />)}
            </div>
            {this.state.currentRole.associatName != "student" && <div className="notification-unread" onClick={this.showUnreadStudentsModal.bind(this, noti.id)}>未读{noti.unread_students.length}人</div>}
            {this.state.currentRole.associatName != "student" && <div className="notification-revoke" onClick={this.showRevokeModal.bind(this, noti.id)}><Icon type="rollback" /> 撤回此条通知</div>}
          </div>
        )}
        {this.state.currentRole.associatName != "student" && <Modal wrapClassName="notifications-unread-students-modal" visible={this.state.unreadStudentsModalVisible} footer={null} onCancel={() => this.setState({unreadStudentsModalVisible: false, focusedNotificationId: null})} >
          <div className="unread-title">未读宝贝</div>
          <div className="unread-students">
            {this.state.focusedNotificationId && this.state.notifications.find(n => n.id == this.state.focusedNotificationId).unread_students.map(student =>
              <div className="unread-student-card" key={student.id}>
                {student.full_name}
              </div>
            )}
          </div>
        </Modal>}
        {this.state.currentRole.associatName != "student" && <Modal wrapClassName="notifications-revoke-modal" visible={this.state.revokeModalVisible} onCancel={() => this.setState({revokeModalVisible: false})} footer={null} >
          <div className="revoke-title">撤回此条通知</div>
          <div className="revoke-confirm-content">{this.state.revokeModalInfo.content}</div>
          {this.state.revokeModalInfo.leftButton  && <div className="revoke-left-button"  onClick={this.state.revokeModalInfo.leftCallback } >{this.state.revokeModalInfo.leftButton }</div>}
          {this.state.revokeModalInfo.rightButton && <div className="revoke-right-button" onClick={this.state.revokeModalInfo.rightCallback} >{this.state.revokeModalInfo.rightButton}</div>}
        </Modal>}
        {this._photoViewModal()}
      </Spin></div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/classinfo/notificationComponents/viewNotificationsOfClassComponent.jsx